import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

import { api } from './libs/api'

import { Configuration } from './constants'

import createApp from './app'
import createRouter from './router'
import createStore from './store'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: Configuration.GOOGLE_MAPS_API_KEY,
    v: 'quarterly',
    libraries: 'places',
  },
})

Promise.all([api.fetchMaster(), api.fetchUser()])
  .then(([masters, currentUser]) =>
    ({ authorized: true, masterLoaded: true, masters, currentUser }))
  .catch(() => ({ authorized: false, masterLoaded: false, masters: [], currentUser: {} }))
  .then((initialState) => {
    const store = createStore(initialState)
    const router = createRouter({ store })
    const app = createApp({ router, store })

    app.$mount('#app')
  })



// WEBPACK FOOTER //
// ./src/main.js